import Nav from "./nav"
import Search from "./search"
import Slider from "./slider"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Slider(jQuery)
})
